import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5em;
  border-radius: 10px;

  ${themeMedia.desktop`
    border: 3px solid ${themeStyles.colors.lightGreys[1].main};
    padding: 2em;
  `}
`
export const StyledValue = styled.p`
  font-size: 4em;
  color: ${themeStyles.colors.lightGreys[4].main};
  margin: 0;

  ${({ theme }) =>
    theme === 'info' &&
    css`
      color: ${themeStyles.colors.defaultColors.orange[450]};
    `}

  ${({ theme }) =>
    theme === 'success' &&
    css`
      color: ${themeStyles.colors.accentColors.primary.main};
    `}

  ${themeMedia.desktop`
    font-size: 5em;
  `}
`
export const StyledLabel = styled.p`
  color: ${themeStyles.colors.lightGreys[4].main};
  margin: 0;

  ${({ theme }) =>
    theme === 'info' &&
    css`
      color: ${themeStyles.colors.defaultColors.orange[450]};
    `}

  ${({ theme }) =>
    theme === 'success' &&
    css`
      color: ${themeStyles.colors.accentColors.primary.main};
    `}
`
